import { createAction } from '@reduxjs/toolkit';
export const LOOKUP_CRM_CONTACT = 'LOOKUP_CRM_CONTACT';
export const lookupCrmContactAction = createAction(LOOKUP_CRM_CONTACT);